export default __webpack_public_path__ + "static/media/up-arrow-orange.adf5e184.svg";